import { render, staticRenderFns } from "./BSA.vue?vue&type=template&id=6722cdce&"
import script from "./BSA.vue?vue&type=script&lang=js&"
export * from "./BSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports